/**
 * 授权模块
 * */
import { login, loginByToken, logout } from '@/api/auth/auth'
import { Message } from 'element-ui'
import { removeSession, setSession, setCookies, removeCookie } from '@/utils/utils'

//申明变量
let state = {
  token: '',
  userInfo: '',
  userId: '',
  srmSupplierId: '',
  sex: '',
  name: ''
}
/**
 * 定义mutatins
 * @type {{SET_TOKEN: mutations.SET_TOKEN, saveUserInfo(*, *=): void, SET_USERINFO: mutations.SET_USERINFO}}
 */
const mutations = {
  /**
   * 配置token到vuex
   * @param state
   * @param token
   * @constructor
   */
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  /**
   * 配置用户信息到vuex
   * @param state
   * @param userInfo
   * @constructor
   */
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  /**
   * 清空vuex中的用户信息
   * @param state
   * @constructor
   */
  CLEAR_USERINFO: (state) => {
    //清除vuex
    state.token = ''
    state.userInfo = {}
    state.userId = ''
    state.srmSupplierId = ''
    state.sex = ''
    state.name = ''

    //清除cookies
    removeCookie('token')
    removeCookie('loginInfo')
    removeCookie('unameId')
    removeCookie('uname')
    removeCookie('srmSupplierId')

    //清除session
    removeSession('token')
    removeSession('uname')
    removeSession('unameId')
    removeSession('username')
    removeSession('userinfo')
    removeSession('srmSupplierId')
  },
  /**
   * 登录成功存储数据
   * @param state
   * @param data
   */
  saveUserInfo(state, data) {
    setSession('token', data.token)
    setSession('uname', data.loginUser.name)
    setSession('unameId', data.loginUser.id)
    setSession('username', data.loginUser.username)
    setSession('srmSupplierId', data.loginUser.srmSupplierId)
    setSession('userinfo', JSON.stringify(data))

    setCookies('token', data.token)
    setCookies('loginInfo', JSON.stringify(data))
    setCookies('srmSupplierId', data.loginUser.srmSupplierId)
    setCookies('uname', data.loginUser.name)

    state.token = data.token
    state.userInfo = data.loginUser
    state.userId = data.loginUser.id
    state.sex = data.loginUser.sex
    state.name = data.loginUser.name
    state.srmSupplierId = data.loginUser.srmSupplierId
  }

}

/**
 * 定义action
 * @type {{logout(*=): Promise<minimist.Opts.unknown>, login(*=, *=): Promise<unknown>, loginByToken(*=): Promise<minimist.Opts.unknown>}}
 */
const actions = {
  /***
   * 登录
   * @param commit 上下文
   * @param userInfo 登录信息
   * */
  login(context, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const { data, code } = response
        if (code === '0') {
          //提交数据
          context.commit('saveUserInfo', data)
          Message({
            message: '登录成功!',
            type: 'success',
            duration: 3 * 1000
          })
          resolve(true)
        } else {
          Message({
            message: response.msg,
            type: 'error',
            duration: 3 * 1000
          })
          resolve(false)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 根据token登录系统
   * @param context
   * @returns {Promise<unknown>}
   */
  loginByToken(context) {
    return new Promise((resolve, reject) => {
      /**
       * 根据token信息登录系统
       */
      loginByToken().then(response => {
        const { data, code } = response
        if (code == '0') {
          //提交数据
          context.commit('saveUserInfo', data)
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 推出登录
   * @param context
   * @returns {Promise<unknown>}
   */
  logout(context, cbk) {
    logout().then(() => {
      //清除vuex
      context.commit('CLEAR_USERINFO', {})
      Message({
        message: '退出登录成功!',
        type: 'success',
        duration: 3 * 1000
      })
      if (typeof (cbk) === 'function') {
        cbk(true)
      }
    }).catch(() => {
      if (typeof (cbk) === 'function') {
        cbk(false)
      }
    })
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state
}

